module.exports = __webpack_public_path__ + "img/android.2072d108.svg";